<template>
  <input
    :value="value"
    :class="[inputVariants({ variant }), $attrs.class] | twMerge"
    @input="onChange"
    v-bind="inputAttrs"
    v-on="inputListeners"
  />
</template>

<script>
import { cva } from 'class-variance-authority';

const inputVariants = cva(
  'gm-text-input bg-gray-50 rounded-lg border focus:outline-primary-600 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        default: '',
        error: 'border-red-500 bg-red-300 placeholder-red-500',
        success: '',
      }
    }
  }
)

export default {
  name: 'TextInput',
  props: {
    variant: String,
    value: {
      type: [String, Number],
      default: ''
    },
  },
  computed: {
    inputAttrs() {
      // eslint-disable-next-line no-unused-vars
      const { class: _, ...attrs } = this.$attrs
      return attrs
    },
    inputListeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners
      return listeners
    }
  },
  methods: {
    inputVariants,
    onChange(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style scoped>
.gm-text-input:focus {
  border-color: rgb(37, 99, 235)
}
</style>
